DM.Service.MegaMenu = (function () {

    var cache = [];

    return {
        _fetchFromServer: function (fetch, url) {
            return fetch(url).then(response => response.json());
        },
        _fetchFromCache: function (cache, url) {
            return cache.filter(function (item) {
                return item.url === url;
            })[0];
        },
        _addToCache: function (arr, data) {
            return arr.push(data);
        },
        getData: function (forcePreview) {
            let url = '/home/megamenu';
            if(forcePreview){
                url += '?p=forcepreview';
            }
            let cached = this._fetchFromCache(cache, url);

            return new Promise((resolve, reject) => {
                if (cached) {
                    resolve(cached.data)
                } else {
                    this._fetchFromServer(fetch, url)
                        .then(function (response) {
                            this._addToCache(cache, {
                                url: url,
                                data: response
                            });
                            resolve(response);
                        }.bind(this)).catch(function (error) {
                        reject(error);
                    });
                }
            });
        }
    };
})();
